(() => {
  if (window.virsaaUpsellLoaded) return;
  window.virsaaUpsellLoaded = true;
  const config = document.getElementById('virsaa-upsell-config');
  if (!config || !window.HTMLDialogElement) return;
  const c = JSON.parse(config.textContent), root = window.Shopify?.routes?.root || '/';
  if (!c.promo || !Array.isArray(c.promo.ids) || !Array.isArray(c.promo.tiers)) return;
  c.handles = c.promo.handles || [];
  const syncedAge = () => Date.now() - Date.parse(c.promo.syncedAt);
  const syncFresh = () => Number.isFinite(syncedAge()) && syncedAge() >= -60000 && syncedAge() < 3 * 60 * 60 * 1000;
  if (!c.promo.enabled || !syncFresh()) return;
  let busy = false, timer, cart, dialog, lastFocus;
  let seen = false;
  try { seen = sessionStorage.getItem('virsaa-upsell-seen-v3') === '1'; } catch (_) {}
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
  const readCart = async () => { const r = await fetch(root + 'cart.js'); if (!r.ok) throw Error(); return r.json(); };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: cart.currency || c.currency }).format(cents / 100);
  let viewed = [];
  try { viewed = JSON.parse(sessionStorage.getItem('virsaa-viewed-v2') || '[]').filter(p => p.id && p.handle).slice(0, 8); } catch (_) {}
  if (c.currentProduct) {
    viewed = [c.currentProduct, ...viewed.filter(p => p.id !== c.currentProduct.id)].slice(0, 8);
    try { sessionStorage.setItem('virsaa-viewed-v2', JSON.stringify(viewed)); } catch (_) {}
  }
  const eligible = new Set(c.promo.ids);
  const offerActive = () => c.promo.enabled && syncFresh() && (!c.promo.endsAt || Date.now() < Date.parse(c.promo.endsAt));
  const rateFor = qty => offerActive() ? c.promo.tiers.reduce((rate, tier) => qty >= tier.quantity ? tier.rate : rate, 0) : 0;
  const replace = (text, data) => Object.entries(data).reduce((s, [key, value]) => s.replaceAll('[' + key + ']', value), text);
  const words = text => new Set(String(text || '').toLowerCase().match(/[a-z]{4,}/g)?.filter(w => !['inspired','fragrance','perfume','virsaa','parfum','alcohol','based','unisex','women','mens'].includes(w)) || []);
  async function show() {
    if (seen || busy || dialog?.open) return;
    busy = true;
    try {
      if (!offerActive()) return;
      cart = await readCart();
      if (!cart.items.length) return;
      const ids = new Set(cart.items.map(i => i.product_id));
      const sources = [...new Set([cart.items[0].product_id, ...viewed.map(p => p.id)])].slice(0, 3);
      const batches = await Promise.all(sources.map(async id => {
        try { const r = await fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=related'); return r.ok ? (await r.json()).products || [] : []; } catch (_) { return []; }
      }));
      let candidates = batches.flat();
      const fallback = await Promise.all([...new Set([...viewed.map(p => p.handle), ...c.handles])].slice(0, 12).map(async h => {
        try { const r = await fetch(root + 'products/' + h + '.js'); return r.ok ? await r.json() : null; } catch (_) { return null; }
      }));
      candidates = [...candidates, ...fallback.filter(Boolean)].filter((p, i, all) => p.available && p.variants.some(v => v.available) && eligible.has(p.id) && !ids.has(p.id) && all.findIndex(x => x.id === p.id) === i);
      const interests = words([...cart.items.map(i => i.product_title), ...viewed.map(p => p.title)].join(' '));
      const score = p => {
        const recent = viewed.findIndex(v => v.id === p.id);
        const affinity = [...words(p.title + ' ' + (p.description || '').replace(/<[^>]+>/g, ' '))].filter(w => interests.has(w)).length;
        return (recent >= 0 ? 30 - recent : 0) + affinity * 3 + (batches[0].some(x => x.id === p.id) ? 8 : 0);
      };
      let products = candidates.sort((a, b) => score(b) - score(a));
      const quantity = cart.items.filter(i => eligible.has(i.product_id) && !i.selling_plan_allocation).reduce((sum, i) => sum + i.quantity, 0);
      const nextTier = offerActive() ? c.promo.tiers.find(t => t.quantity > quantity) : null;
      const targetRate = nextTier?.rate || rateFor(quantity);
      products = products.slice(0, 3);
      if (!products.length) return;
      lastFocus = document.activeElement;
      document.querySelector('cart-drawer')?.close?.();
      document.querySelector('cart-notification')?.close?.();
      dialog = el('dialog', 'vu-dialog');
      dialog.setAttribute('aria-labelledby', 'vu-title');
      const close = el('button', 'vu-close', '×'); close.type = 'button'; close.setAttribute('aria-label', c.close);
      close.onclick = () => dialog.close();
      dialog.append(close, el('p', 'vu-eyebrow', offerActive() ? c.offerBadge : 'VIRSAA 1947'));
      const title = el('h2', '', nextTier ? replace(c.unlock, {count: nextTier.quantity - quantity, percent: Math.round(nextTier.rate * 100)}) : c.title);
      title.id = 'vu-title';
      const intro = nextTier ? replace(c.offerIntro, {percent: Math.round(nextTier.rate * 100)}) : c.intro;
      dialog.append(title, el('p', 'vu-intro', intro));
      if (offerActive()) {
        const tiers = el('div', 'vu-tiers');
        c.promo.tiers.forEach(t => { const pill = el('span', quantity >= t.quantity ? 'vu-tier vu-earned' : 'vu-tier', replace(c.tier, {count:t.quantity, percent:Math.round(t.rate * 100)})); tiers.append(pill); });
        dialog.append(tiers);
      }
      const shipping = el('div', 'vu-shipping');
      shipping.setAttribute('role', 'status');
      const shippingText = el('p'), shippingTrack = el('div', 'vu-shipping-track'), shippingFill = el('span');
      shippingTrack.append(shippingFill); shipping.append(shippingText, shippingTrack); dialog.append(shipping);
      function paintShipping(subtotal, estimate = false) {
        if ((cart.currency || c.currency) !== 'AUD') { shippingText.textContent = c.shippingGeneral; shippingTrack.hidden = true; return; }
        const remaining = Math.max(0, 15000 - subtotal);
        shippingText.textContent = remaining === 0 ? (estimate ? c.shippingEstimated : c.shippingUnlocked) : replace(estimate ? c.shippingSelectionGap : c.shippingGap, {amount:money(remaining)});
        shippingFill.style.width = Math.min(100, Math.max(0, subtotal / 15000 * 100)) + '%';
        shipping.classList.toggle('vu-shipping-earned', remaining === 0);
      }
      paintShipping(cart.total_price);
      dialog.append(el('p', 'vu-personal', viewed.length ? c.viewedLabel : c.cartLabel));
      const list = el('div', 'vu-list'), selected = [];
      products.forEach(p => {
        const card = el('div', 'vu-card'), label = el('label', 'vu-choice'), check = el('input'); check.type = 'checkbox';
        const name = p.title.split('|')[0].trim(); check.setAttribute('aria-label', c.select + ' ' + name);
        const image = el('img'); const src = p.featured_image?.url || p.featured_image || p.images?.[0];
        if (src) { image.src = src; image.alt = name; image.width = 120; image.height = 140; image.loading = 'lazy'; }
        label.append(check, image); const details = el('div', 'vu-details');
        const link = el('a', 'vu-name', name); link.href = root + 'products/' + p.handle;
        const variants = p.variants.filter(v => v.available), select = el('select', 'vu-variant'); select.setAttribute('aria-label', name + ' ' + c.variant);
        variants.forEach(v => { const o = el('option', '', v.title === 'Default Title' ? c.standard : v.title); o.value = v.id; select.append(o); });
        const price = el('p', 'vu-price');
        const paintPrice = () => { const v = variants.find(v => String(v.id) === select.value); price.replaceChildren(); if (targetRate) price.append(el('s', 'vu-original', money(v.price)), el('strong', '', money(Math.round(v.price * (1 - targetRate))))); else price.textContent = money(v.price); };
        paintPrice();
        select.onchange = () => { paintPrice(); update(); };
        check.onchange = update;
        details.append(link, price); if (variants.length > 1) details.append(select);
        card.append(label, details); list.append(card); selected.push({check, select, variants});
      });
      const summary = el('p', 'vu-summary', offerActive() ? replace(c.priceNote, {percent:Math.round(targetRate*100)}) : c.regularNote);
      const status = el('p', 'vu-status'); status.setAttribute('role', 'status');
      const add = el('button', 'vu-add', c.add); add.type = 'button'; add.disabled = true;
      function update() {
        const chosen = selected.filter(x => x.check.checked);
        add.disabled = !chosen.length;
        const total = chosen.reduce((s,x) => s + x.variants.find(v => String(v.id) === x.select.value).price, 0);
        const rate = rateFor(quantity + chosen.length);
        const eligibleLines = cart.items.filter(i => eligible.has(i.product_id) && !i.selling_plan_allocation);
        const originalEligible = eligibleLines.reduce((sum, i) => sum + i.original_line_price, 0);
        const currentEligible = eligibleLines.reduce((sum, i) => sum + i.final_line_price, 0);
        const estimate = cart.total_price - currentEligible + Math.round((originalEligible + total) * (1-rate));
        paintShipping(chosen.length ? estimate : cart.total_price, chosen.length > 0);
        if (chosen.length) {
          add.textContent = replace(c.addCount, {count:chosen.length}) + (rate ? ' · ' + replace(c.savePercent,{percent:Math.round(rate*100)}) : '');
          summary.textContent = replace(c.selectionNote, {amount:money(Math.round(total*(1-rate))), percent:Math.round(rate*100)});
        } else { add.textContent = c.add; summary.textContent = offerActive() ? replace(c.priceNote,{percent:Math.round(targetRate*100)}) : c.regularNote; }
      }
      add.onclick = async () => {
        if (busy) return;
        busy = true; add.disabled = true; status.textContent = c.adding;
        try {
          const r = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:selected.filter(x=>x.check.checked).map(x=>({id:Number(x.select.value),quantity:1}))})});
          const data = await r.json(); if (!r.ok) throw Error(data.description || c.error);
          status.textContent = c.added;
          window.location.assign(root + 'cart');
        } catch (e) { status.textContent = e.message || c.error; busy = false; update(); }
      };
      const skip = el('button', 'vu-skip', c.skip); skip.type = 'button'; skip.onclick = () => dialog.close();
      const view = el('a', 'vu-view', c.cart); view.href = root + 'cart';
      const viewAll = el('a', 'vu-view-all', c.viewAll); viewAll.href = root + 'collections/edp';
      dialog.append(list, viewAll, summary, status, add, view, skip);
      dialog.addEventListener('click', e => { if (e.target === dialog) { const b = dialog.getBoundingClientRect(); if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { dialog.remove(); lastFocus?.focus?.(); });
      document.body.append(dialog); dialog.showModal(); seen = true;
      try { sessionStorage.setItem('virsaa-upsell-seen-v3', '1'); } catch (_) {}
    } catch (_) {} finally { busy = false; }
  }
  if (window.PerformanceObserver) {
    const observer = new PerformanceObserver(entries => {
      if (seen || busy) return;
      if (entries.getEntries().some(e => { const u = new URL(e.name, location.href); return u.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(u.pathname); })) { clearTimeout(timer); timer = setTimeout(show, 650); }
    });
    observer.observe({type:'resource', buffered:false});
  }
  if (/\/cart\/?$/.test(location.pathname)) setTimeout(show, 700);
})();
